export default __webpack_public_path__ + "static/media/footer-logo.743ec5ce.png";